import { installSearchSelects } from '@/shared/selects/plugin'
import Vue from 'vue'
import Relationships from '@/shared/relationships/plugin'
import { registerCommercialRelationships } from './services/commercial/relationships'
Vue.use(Relationships)
registerCommercialRelationships(Vue)
import { installModalChanges } from './services/modalChanges'
installModalChanges()
import App from './App.vue'
import router from './router'
import store from './store'
import jQuery from 'jquery'
import vSelect from "vue-select"
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/pt-br';
import Axios from 'axios'
import Swal from 'sweetalert2'
import VueTheMask from 'vue-the-mask'
import money from 'v-money'
import "vue-select/dist/vue-select.css"
import { Cropper } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';
import highcharts from 'highcharts'
import highchartsVue from 'highcharts-vue'
import VariablePie from "highcharts/modules/variable-pie"

global.jQuery = jQuery
global.$ = jQuery

// Configurar Axios com withCredentials para enviar cookies automaticamente
Axios.defaults.withCredentials = true
Axios.defaults.headers.common['ngrok-skip-browser-warning'] = '69420'

// Sempre configura o header Authorization caso haja token salvo
const tokenDeStore = store.state.tokenSessao || localStorage.getItem('tokenSessao')
if (tokenDeStore) {
   Axios.defaults.headers.common['Authorization'] = 'Bearer ' + tokenDeStore
}

// Interceptor global do Axios para SEMPRE anexar Authorization em todas as requisições
Axios.interceptors.request.use((config) => {
   const token = store.state.tokenSessao || localStorage.getItem('tokenSessao')
   if (token) {
      config.headers.Authorization = 'Bearer ' + token
   }
   return config
})

Vue.prototype.$axios = Axios
const toastMixin = Swal.mixin({
   toast: true,
   position: 'top-end',
   showConfirmButton: false,
   timer: 3500,
   timerProgressBar: true,
   didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
   }
})
toastMixin.error = (title, text) => toastMixin.fire({ icon: 'error', title, text })
toastMixin.success = (title, text) => toastMixin.fire({ icon: 'success', title, text })
toastMixin.warning = (title, text) => toastMixin.fire({ icon: 'warning', title, text })
toastMixin.info = (title, text) => toastMixin.fire({ icon: 'info', title, text })
Vue.prototype.$toast = toastMixin

Vue.directive('focus', {
   inserted: function (el) {
      try {
         if (!window.matchMedia("(pointer: coarse)").matches) {
            el.focus()
         }
      } catch (error) {
         console.log(error)
      }
   }
})

Vue.directive('permission', {
   inserted: function (el, binding, vnode) {
      const requiredRole = binding.value;
      if (!requiredRole) return;
      
      const user = vnode.context.$store.state.dadosUsuario;
      if (!user) {
         el.parentNode && el.parentNode.removeChild(el);
         return;
      }
      
      const roles = user.roles || [];
      const modules = user.modules || [];
      
      let hasRole = roles.includes(requiredRole);
      
      // COMPANY_ADMIN possui acesso total por padrão (mesma regra do backend)
      if (!hasRole && modules.includes('COMPANY_ADMIN')) {
          hasRole = true;
      }
      
      if (!hasRole) {
         el.parentNode && el.parentNode.removeChild(el);
      }
   }
})

require('@/assets/plugins/simplebar/simplebar.css')
require('@/assets/plugins/perfect-scrollbar/perfect-scrollbar.css')
require('@/assets/plugins/metisMenu/metisMenu.min.css')
require('@/assets/css/fontAwesome5Pro.css')
require('@/assets/css/bootstrap.min.css')
require('@/assets/css/app.css')
require('@/assets/css/icons.css')
require('@/assets/css/dark-theme.css')
require('@/assets/css/semi-dark.css')
require('@/assets/css/header-colors.css')
require('@/assets/css/gerencial-visual.css')
require('@/assets/css/gerencial-layout.css')
require('@/assets/css/modal-tabs.css')
require('@/assets/css/commercial.css')

require('@/assets/plugins/metisMenu/metisMenu.min.js')
require('@/assets/js/bootstrap.bundle.min.js')
require('@/shared/selects/select.css')

VariablePie(highcharts)

Vue.use(highchartsVue)
Vue.use(VueTheMask)
Vue.use(money, {precision: 2, decimal: ',', thousands: '.', prefix: 'R$ ', masked: false})
Vue.component(Cropper)
installSearchSelects(Vue, vSelect)
Vue.component('datePicker', DatePicker)

Vue.config.productionTip = false

new Vue({
   router,
   store,
   render: h => h(App)
}).$mount('#app')
